import { type CustomerOrdersListParams } from './use-customer-orders-list';
import usePaginatedList, { type PaginatedListResult } from './use-paginated-list';
import {
  type ArchivedCustomerOrderListItemDto,
  toArchivedCustomerOrder,
} from '../dto/customer-order/archived-customer-order-list-item-dto';
import { type ArchivedCustomerOrder } from '../entities';
import { ARCHIVED_CUSTOMER_ORDER_END_POINT_URL } from '../utils/endpoints';

export type ArchivedCustomerOrdersListResult = PaginatedListResult<ArchivedCustomerOrder>;

/**
 * Loads a page of the archived customer orders which the current user can read, from the archived customer order
 * controller. It takes the same filters as the customer orders list, and loads again whenever the content of
 * "params" changes or "refetch" is called. A failed load clears the list and sets "errorMessage".
 */
const useArchivedCustomerOrdersList = (
  params: CustomerOrdersListParams
): ArchivedCustomerOrdersListResult =>
  usePaginatedList<ArchivedCustomerOrderListItemDto, ArchivedCustomerOrder>(
    ARCHIVED_CUSTOMER_ORDER_END_POINT_URL,
    params,
    toArchivedCustomerOrder,
    'Failed to load archived orders'
  );

export default useArchivedCustomerOrdersList;
